import React, { useEffect, useRef, useState } from 'react';
import { updateClient } from '../../api/clients';
import { DealsAPI } from '../../api/deals';

interface Props {
  clientId: number;
  dealId?: number;
  phone: string;
  onClose: () => void;
}

export default function ClientNameModal({ clientId, dealId, phone, onClose }: Props) {
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const firstRef = useRef<HTMLInputElement>(null);

  useEffect(() => { firstRef.current?.focus(); }, []);

  const save = async () => {
    const ln = lastName.trim();
    const fn = firstName.trim();
    if (!ln || !fn) {
      setError('Укажите фамилию и имя');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const mn = middleName.trim();
      await updateClient(clientId, { lastName: ln, firstName: fn, middleName: mn || null });
      if (dealId) {
        await DealsAPI.update(dealId, { title: `Входящий звонок ${ln} ${fn}` }).catch(() => {});
      }
      onClose();
    } catch {
      setError('Не удалось сохранить. Попробуйте ещё раз.');
    } finally {
      setSaving(false);
    }
  };

  const onKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') save();
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={{ fontSize: 13, color: '#9ca3af' }}>Звонок завершён</div>
        <h2 style={{ margin: '4px 0 2px', fontSize: 20, color: '#f3f4f6' }}>Укажите ФИО клиента</h2>
        <div style={{ fontSize: 14, color: '#7ec8e3', marginBottom: 16 }}>{phone}</div>

        <label style={label}>Фамилия *</label>
        <input ref={firstRef} style={input} value={lastName} onChange={(e) => setLastName(e.target.value)} onKeyDown={onKey} />

        <label style={label}>Имя *</label>
        <input style={input} value={firstName} onChange={(e) => setFirstName(e.target.value)} onKeyDown={onKey} />

        <label style={label}>Отчество</label>
        <input style={input} value={middleName} onChange={(e) => setMiddleName(e.target.value)} onKeyDown={onKey} />

        {error && <div style={{ color: '#f87171', fontSize: 13, marginTop: 10 }}>{error}</div>}

        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button style={{ ...btn, background: '#2563eb', flex: 1 }} onClick={save} disabled={saving}>
            {saving ? 'Сохраняем…' : 'Сохранить'}
          </button>
          <button style={{ ...btn, background: '#374151' }} onClick={onClose} disabled={saving}>Позже</button>
        </div>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = {
  position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.65)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
};
const modal: React.CSSProperties = {
  width: '100%', maxWidth: 400, background: '#131926', border: '1px solid #1f2937',
  borderRadius: 14, padding: 24, boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
};
const label: React.CSSProperties = { display: 'block', fontSize: 12, fontWeight: 600, color: '#9ca3af', margin: '10px 0 5px' };
const input: React.CSSProperties = {
  width: '100%', boxSizing: 'border-box', padding: '10px 12px', fontSize: 15, color: '#fff',
  background: '#1a2030', border: '1px solid #374151', borderRadius: 8, outline: 'none',
};
const btn: React.CSSProperties = {
  color: '#fff', border: 'none', borderRadius: 8, padding: '11px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
};
